module.exports = __webpack_public_path__ + "media/ft.decf0182.mp3";